<template>
  <div :class="{ text: true, 'text--white': white }">
    <Wrap>
      <div class="text__wrapper">
        <div class="text__heading">
          <Title :title="heading" :subtitle="subtitle" />
        </div>
        <div :class="{ 'text__body': true, 'text__body--alt':white, 'text__body--full':full }">
          <slot />
        </div>
      </div>
    </Wrap>
  </div>
</template>

<script>
export default {
  name: "Text",
  props: {
    white: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: "Wie zoeken wij?",
    
    },
    subtitle: {
      type: String,
      default: "",
    },
    full: {
      type: Boolean,
      default: false,
    },
    footer: {
      type: String,
      default: "Iemand met passie voor het web en de techniek erachter.",
    },
  },
};
</script>

<style scoped lang="scss">
  
.text {
  background-color: black;
  color: white;
  
  &__wrapper {
      padding: 6rem 0;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      gap: 2rem;
      min-height: 50vh;
      @media (width > 600px) {
        min-height: 100vh;
      }
  }

  &__heading {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  &--white {
    background-color: white;
    color: black;
  }

  &__body {
    font-size: clamp(1rem, 0.8977rem + 0.4545vw, 1.25rem);
    font-weight: 500;
    max-width: 100%;

    @media (width > 600px) {
      max-width: 800px;
    }
    
    &--alt {
      text-align: left;
      align-self: flex-start;
      max-width: 100%;
      
      @media (width > 600px) {
        &:not(:has(.columns)){
          text-align: right;
          align-self: flex-end;
          max-width: 800px;
        }
      }
    }

    &--full {
      max-width: 100%;
    }
  }
}
</style>
